import React from "react";
import EachPricing from "./EachPricing/EachPricing";
import "./Pricing.css";
const Pricing = () => {
    const freeData = {
        title: "Free",
        tag: "Free for Lifetime",
        price: 0,
        features: [
          "Sales Tracking",
          "Income Tracking",
          "Due Tracking",
          "Expense Tracking",
          "Dashboard Reporting",
          "Hishabee Marketing",
          "Customer Management",
          "Multi-Language Support",
        ],
      };
  const standardData = {

    title: "Standard",
    tag: "Monthly",
    price: 60,
    features: [
      "Everything in Free",
      "POS System",
      "Digital Receipts",
      "Bluetooth Printer Integration",
      "Barcode Scanner",
      "Stock Counting",
      "Full Account Book Management",
      "Digital Payment Collection",
      "More exclusive features incoming",
    ],
  };
  const advanceData = {
    title: "Advanced",
    tag: "Monthly",
    price: 98,
    features: [
      "Eveything in Standard",
      "Personal E-Commerce Store",
      "Due Alert",
      "Employee Management",
      "Customer and Vendor Chat",
      "Qr Code Payments",
      "EMI Facility",
      "More exclusive features incoming",
    ],
    
  };

  return (
    <div className="pricing">
      <h3>Flexible pricing plan for your startup</h3>
      <p>Pricing that scales with your business immediately.</p>
      <div className="pricing-details">
        <EachPricing value={freeData} />
        <EachPricing value={standardData} />
        <EachPricing value={advanceData} />
      </div>
    </div>
  );
};

export default Pricing;
